import { LAYERS, layersByGroup } from "layers/layers";

import {
  ConfigurableLayer,
  ConfigurableLayerMap,
  LayerGroupName,
  LayerName,
} from "types/dataModel";

function extractLayers(
  layers: LayerName[] | ConfigurableLayerMap,
  layersToggle: Record<LayerName, boolean>,
) {
  if (Array.isArray(layers)) {
    return layers.map((name) => LAYERS[name]);
  }

  return (
    Object.entries(layers).filter(([name, configLayer]) => {
      if (!layersToggle) {
        return true;
      }
      if (!configLayer.hasOwnProperty("selectKey")) {
        return true;
      }
      return layersToggle[name as LayerName];
    }) as [LayerName, ConfigurableLayer][]
  ).map(([name, configurableLayer]) => LAYERS[name] || configurableLayer);
}

export default function getLayers(
  key: LayerGroupName,
  args: Record<string, any>,
  layersToggle: Record<LayerName, boolean>,
) {
  const rawLayers = layersByGroup[key];
  const layers = extractLayers(rawLayers, layersToggle);
  if (!layers || !layers[0])
    return {
      legends: [],
      layers: [],
    };

  const selectionDependencies = layers
    .filter((l) => l.selection_dependent_on)
    .map((l) => [l.selection_dependent_on, l.source_layer]);
  const subgroups = layers.filter((l) => l.is_subgroup);
  const layersWithProtos = layers.map((l) => {
    // @ts-ignore JCM - these things all have different signatures and typescript is unhappy about it.
    return new l.layer_prototype({ ...l, ...args });
  });
  const layers_to_return = layersWithProtos.map((l) => l.MBLayer);
  const legends_to_return = layersWithProtos
    .filter((l) => l.display_legend)
    .map((l) => l.Legend);

  return {
    legends: legends_to_return,
    layers: layers_to_return,
    selectionDependencies: selectionDependencies,
    subgroups: subgroups,
  };
}
